import React, { useEffect, useState } from "react";
import { getPackingList, orderInvoice } from "../../../services/apiService";
import logo from "../../../assets/logo.png";

const Dispatch = () => {
  const [date, setDate] = useState("");
  const [time, setTime] = useState("");
  const [data, setData] = useState([]);
  const [invoicedata, setInvoiceData] = useState([]);
  // const [hdr, sethdr] = useState([]);
  const [bill, setBill] = useState([]);
  // const [ship, setShip] = useState([]);
  const [loading, setLoading] = useState(false);

  //   const rawDate = hdr[0].orderdate;
  // const d = new Date(rawDate);

  // const formattedDate =
  //   String(d.getDate()).padStart(2, "0") + "-" +
  //   String(d.getMonth() + 1).padStart(2, "0") + "-" +
  //   d.getFullYear();

  useEffect(() => {
    fetchOrders();
  }, []);

  const fetchOrders = async () => {
    try {
      setLoading(true);
      const res = await getPackingList();
      setData(res.Data || []);
      console.log(res);
    } catch (error) {
      console.error("Packing list error:", error);
    } finally {
      setLoading(false);
    }
  };

  const invoice = async (orderid) => {
    try {
      const res = await orderInvoice(orderid);
      console.log(res);
      setInvoiceData(res.data)
      // sethdr(res.hdr)
      setBill(res.Bill)
      // setShip(res.Ship)
      handlePrintWaybill(res.data, res.Ship, res.hdr)
    } catch (error) {
      console.error("Packing list error:", error);
    } finally {
      console.log('printing invoice')
    }
  };


//   const generateWaybillHTML = (order, ship, hdr) => {
//     return `
// <html>
// <head>
//   <title>Waybill</title>

//   <!-- LOAD BARCODE LIBRARY -->
//   <script src="https://cdn.jsdelivr.net/npm/jsbarcode@3.11.6/dist/JsBarcode.all.min.js"></script>

//   <script>
//     window.onload = function () {

//       JsBarcode("#barcode", "${hdr[0]?.dispatchid}", {
//         format: "CODE128",
//         width: 2,
//         height: 30,
//         displayValue: true
//       });

//      JsBarcode("#barcode2", "${hdr[0]?.orderid}", {
//     format: "CODE128",
//     width: 2,
//     height: 30,
//     displayValue: true
//   });

//   setTimeout(() => {
//     window.print();
//     window.close();
//   }, 500);
// };
//   </script>

//   <style>
//   @page {
//   size: A4 landscape;
//   margin: 0;
// }
//   body {
//     font-family: Arial, sans-serif;
//     padding: 8px;
//     font-size: 12px;
//   }

//   .container {
//     border: 1px solid #000;
//     padding: 10px;
//     display: flex;
//     width: 50%;
//     position: absolute;
//     left: 0;
//     top: 0;
//   }

//   .header {
//     display: flex;
//     justify-content: space-between;
//     align-items: center;
//   }

//   .header img {
//     height: 30px;
//   }

//   hr {
//     margin: 6px 0;
//   }

//   p {
//     margin: 2px 0;
//   }

//   strong {
//     font-size: 12px;
//   }

//   svg {
//     margin: 4px 0;
//   }

//   table {
//     width: 100%;
//     border-collapse: collapse;
//     margin-top: 8px;
//     font-size: 11px;
//   }

//   th, td {
//     border-bottom: 1px solid #ccc;
//     padding: 4px;
//     text-align: left;
//   }

//   th {
//     font-weight: bold;
//   }

//   .section-border {
//     border-top: 1px solid #000;
//     border-bottom: 1px solid #000;
//     padding: 6px 0;
//     margin: 6px 0;
//   }

//   .footer {
//     font-size: 10px;
//     margin-top: 6px;
//   }
// </style>
// </head>

// <body>
//   <div class="container">

//     <div class="header">
//             <img src="${logo}" style="height:30px;" />
//       <img src="data:image/png;base64,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" style="height:30px;" />
//     </div>

//     <hr/>

//     <div class="section-border"">
//       <strong>Ship To:</strong>
//       <p><strong>${ship[0]?.name}</strong></p>
//       <p>${ship[0]?.flathouse} - ${ship[0]?.landmark}</p>
//       <p>${ship[0]?.city} - ${ship[0]?.pincode}</p>
//       <p>${ship[0]?.state}, ${ship[0]?.country}</p>
//       <p>Mobile : ${ship[0]?.phone}</p>
//       <p>Alt.Mobile : ${ship[0]?.altphone}</p>

//       <div style="text-align:center;border-bottom:1px solid #000;">
//         <svg id="barcode"></svg>
      
//       </div>
//       <p><strong>ORDER Details</strong></p>
//        <div style="display:flex; justify-content:space-between; border-bottom:1px solid #000; padding:2px 0;"> 
//        <p><strong>ORDER NO:</strong> ${hdr[0]?.orderid}</p>
//         <p><strong>ORDER DATE:</strong> ${(() => {
//         const d = new Date(hdr[0]?.orderdate);
//         return `${String(d.getDate()).padStart(2, "0")}-${String(d.getMonth() + 1).padStart(2, "0")}-${d.getFullYear()}`;
//       })()}</p> 
//         <p><strong>SURFACE:</strong> ONLINE</p></div>
//         <strong style='display:block;margin-top:10px;'>Seller Details: Pixel</strong>
//       <p><strong>Address</strong> Plot No -F4,CICCI FLO, industrial Park Sultanpur,</p>
//       <p>Sultanpur Village,Ameenpur Mandal,</p>
//       <p>Sangareddy-502319,</p>
//       <p>Hyderabad,Telangana</p>
//       <div style="text-align:center;margin-top:10px;border-bottom:1px solid #000;">
//         <svg id="barcode2"></svg>
        
//       </div>
//             <table>
//   <tr>
//     <th>Product (Qty)</th>
//     <th>No of Cartons</th>
//     <th>Price</th>
//     <th>GST</th>
//     <th>Coupon</th>
//     <th>Delivery Amount</th>
//     <th>Grand Total</th>
//   </tr>

//     <tr>
//       <td>${order.reduce((s, i) => s + (i.orderqty || 0), 0)}</td>
//       <td>${hdr[0]?.noofcartoon}</td>
//       <td>₹${hdr[0]?.amount}</td>
//       <td>₹${hdr[0]?.gstamount}</td>
//       <td>₹${hdr[0]?.couponamount || 0}</td>
//       <td>₹${hdr[0]?.delivarycharges}</td>
//       <td>₹${hdr[0]?.netamount}</td>
//     </tr>

// </table>
//              <div class="footer"> <p><strong>Return Address:</strong> Plot No -F4,CICCI FLO, industrial Park Sultanpur,
// Sultanpur Village,Ameenpur Mandal,
// Sangareddy-502319,
// Hyderabad,Telangana
// </p> </div>
//     </div>

//   </div>
// </body>
// </html>
// `;
//   };

  const generateWaybillHTML = (order, ship, hdr) => {
  return `
<html>
<head>
<title> </title>

  <script src="https://cdn.jsdelivr.net/npm/jsbarcode@3.11.6/dist/JsBarcode.all.min.js"></script>

  <script>
    window.onload = function () {

      JsBarcode("#barcode", "${hdr[0]?.dispatchid}", {
        format: "CODE128",
        width: 2,
        height: 30,
        displayValue: true
      });

      JsBarcode("#barcode2", "${hdr[0]?.orderid}", {
        format: "CODE128",
        width: 2,
        height: 30,
        displayValue: true
      });

      setTimeout(() => {
        window.print();
        window.close();
      }, 500);
    };
  </script>

  <style>
    @page {
      size: A4 landscape;
      margin: 0;
    }

    body {
      font-family: Arial, sans-serif;
      margin: 0;
      padding: 0;
      font-size: 12px;
    }

    /* FULL PAGE */
    .page {
      width: 100%;
      height: 100%;
      position: relative;
    }

    /* LEFT HALF PRINT AREA */
    .print-half {
      width: 45%;
      padding: 10px 10px 10px 30px;
      box-sizing: border-box;
    }

    .container {
      border: 1px solid #000;
      padding: 10px;
    }

    .header {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .header img {
      height: 30px;
    }

    hr {
      margin: 6px 0;
    }

    p {
      margin: 2px 0;
    }

    svg {
      margin: 4px 0;
    }

    table {
      width: 100%;
      border-collapse: collapse;
      margin-top: 8px;
      font-size: 11px;
    }

    th, td {
      border-bottom: 1px solid #ccc;
      padding: 4px;
      text-align: left;
    }

    .section-border {
      border-top: 1px solid #000;
      border-bottom: 1px solid #000;
      padding: 6px 0;
      margin: 6px 0;
    }

    .footer {
      font-size: 10px;
      margin-top: 6px;
    }
  </style>
</head>

<body>

  <div class="page">

    <!-- LEFT HALF -->
    <div class="print-half">
      <div class="container">

        <div class="header">
          <img src="${logo}" />
      <img src="data:image/png;base64,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" />
        </div>

        <hr/>

        <div class="section-border">
          <strong>Ship To:</strong>
          <p><strong>${ship[0]?.name}</strong></p>
          <p>${ship[0]?.flathouse} - ${ship[0]?.landmark}</p>
          <p>${ship[0]?.city} - ${ship[0]?.pincode}</p>
          <p>${ship[0]?.state}, ${ship[0]?.country}</p>
          <p>Mobile : ${ship[0]?.phone}</p>
          <p>Alt.Mobile : ${ship[0]?.altphone}</p>

          <div style="text-align:center;border-bottom:1px solid #000;">
            <svg id="barcode"></svg>
          </div>

          <p><strong>ORDER Details</strong></p>

          <div style="display:flex; justify-content:space-between; border-bottom:1px solid #000; padding:2px 0;"> 
            <p><strong>ORDER NO:</strong> ${hdr[0]?.orderid}</p>
            <p><strong>ORDER DATE:</strong> ${
              (() => {
                const d = new Date(hdr[0]?.orderdate);
                return `${String(d.getDate()).padStart(2,"0")}-${String(d.getMonth()+1).padStart(2,"0")}-${d.getFullYear()}`;
              })()
            }</p> 
            <p><strong>SURFACE:</strong> ONLINE</p>
          </div>

          <strong style='display:block;margin-top:10px;'>Seller Details: Pixel</strong>
          <p>Plot No -F4,CICCI FLO, industrial Park Sultanpur,</p>
          <p>Sultanpur Village,Ameenpur Mandal,</p>
          <p>Sangareddy-502319,</p>
          <p>Hyderabad,Telangana</p>

          <div style="text-align:center;margin-top:10px;border-bottom:1px solid #000;">
            <svg id="barcode2"></svg>
          </div>

          <table>
            <tr>
              <th>Product (Qty)</th>
              <th>No of Cartons</th>
              <th>Price</th>
              <th>GST</th>
              <th>Coupon</th>
              <th>Delivery</th>
              <th>Total</th>
            </tr>

            <tr>
              <td>${order.reduce((s, i) => s + (i.orderqty || 0), 0)}</td>
              <td>${hdr[0]?.noofcartoon}</td>
              <td>₹${Number(hdr[0]?.amount || 0).toFixed(2)}</td>
              <td>₹${Number(hdr[0]?.gstamount || 0).toFixed(2)}</td>
              <td>₹${Number(hdr[0]?.couponamount || 0).toFixed(2)}</td>
              <td>₹${Number(hdr[0]?.delivarycharges || 0).toFixed(2)}</td>
              <td>₹${Number(hdr[0]?.netamount || 0).toFixed(2)}</td>
            </tr>
          </table>

          <div class="footer">
            <p><strong>Return Address:</strong> Plot No -F4,CICCI FLO, industrial Park Sultanpur,
            Sultanpur Village,Ameenpur Mandal,
            Sangareddy-502319,
            Hyderabad,Telangana</p>
          </div>

        </div>

      </div>
    </div>

    <!-- RIGHT HALF EMPTY -->
    <div style="position:absolute; right:0; top:0; width:50%; height:100%;"></div>

  </div>

</body>
</html>
`;
};

const handlePrintWaybill = (order, ship, hdr) => {
  const iframe = document.createElement("iframe");

  // Hide iframe
  iframe.style.position = "fixed";
  iframe.style.right = "0";
  iframe.style.bottom = "0";
  iframe.style.width = "0";
  iframe.style.height = "0";
  iframe.style.border = "0";

  document.body.appendChild(iframe);

  const doc = iframe.contentWindow.document;
  doc.open();
  doc.write(generateWaybillHTML(order, ship, hdr));
  doc.close();

  iframe.onload = () => {
    setTimeout(() => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();

      // Remove iframe after print
      setTimeout(() => {
        document.body.removeChild(iframe);
      }, 1000);

    }, 500); // wait for barcode render
  };
};
  // const handlePrintWaybill = (order, ship, hdr) => {
  //   const printWindow = window.open("", "_blank", "width=1000,height=1600");
  //   printWindow.document.write(generateWaybillHTML(order, ship, hdr));
  //   printWindow.document.close();
  // };


  return (
    <div style={{ padding: "20px" }}>
      <h4>Dispatch Schedule</h4>

      {/* Date & Time Row */}
      <div style={{ display: "flex", gap: "12px", maxWidth: 500, marginBottom: 20 }}>
        <div style={{ flex: 1 }}>
          <label style={{ fontSize: 13, color: "#555" }}>Date</label>
          <input
            type="date"
            value={date}
            onChange={(e) => setDate(e.target.value)}
            style={{
              width: "100%",
              padding: "6px 8px",
              borderRadius: 6,
              border: "1px solid #ccc",
            }}
          />
        </div>

        <div style={{ flex: 1 }}>
          <label style={{ fontSize: 13, color: "#555" }}>Time</label>
          <input
            type="time"
            value={time}
            onChange={(e) => setTime(e.target.value)}
            style={{
              width: "100%",
              padding: "6px 8px",
              borderRadius: 6,
              border: "1px solid #ccc",
            }}
          />
        </div>
      </div>

      {/* Table */}
      {loading ? (
        <p>Loading orders...</p>
      ) : (
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr style={{ background: "#f3f4f6" }}>
              <th style={thStyle}>Order ID</th>
              <th style={thStyle}>Amount</th>
              <th style={thStyle}>Action</th>
            </tr>
          </thead>
          <tbody>
            {data.length === 0 ? (
              <tr>
                <td colSpan="3" style={{ textAlign: "center", padding: 12 }}>
                  No orders found
                </td>
              </tr>
            ) : (
              data.map((item, index) => (
                <tr key={index}>
                  <td style={tdStyle}>{item.orderid}</td>
                  <td style={tdStyle}>₹{Number(item.billing || 0).toFixed(2)}</td>
                  <td style={tdStyle}>
                    <button
                      onClick={() => invoice(item.orderid)}
                      style={btnStyle}
                    >
                      Print Waybill
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      )}
    </div>
  );
};

const thStyle = {
  padding: "10px",
  border: "1px solid #ddd",
  textAlign: "left",
  fontSize: 14,
};

const tdStyle = {
  padding: "10px",
  border: "1px solid #ddd",
  fontSize: 13,
};

const btnStyle = {
  padding: "6px 10px",
  borderRadius: 6,
  border: "none",
  backgroundColor: "#009b77",
  color: "#fff",
  cursor: "pointer",
  fontSize: 12,
};

export default Dispatch;
